var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.332,
    height: 15.305,
    viewBox: "0 0 13.332 15.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(-1809.117 57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1809.117 -57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.48,35.1H18.5l-1.275,1.377a.68.68,0,1,0,.986.935l2.228-2.381a.68.68,0,0,0,0-1.19l-2.228-2.381a.68.68,0,1,0-.986.935L18.5,33.741H11.48a.68.68,0,0,0,0,1.36Z",
    transform: "translate(-10.8 -26.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M41.193,5H34.73A1.53,1.53,0,0,0,33.2,6.53V9.081a.68.68,0,0,0,1.36,0V6.53a.17.17,0,0,1,.17-.17h6.462a.17.17,0,0,1,.17.17V18.774a.17.17,0,0,1-.17.17H34.73a.17.17,0,0,1-.17-.17V16.224a.68.68,0,1,0-1.36,0v2.551a1.53,1.53,0,0,0,1.53,1.53h6.462a1.53,1.53,0,0,0,1.53-1.53V6.53A1.53,1.53,0,0,0,41.193,5Z",
    transform: "translate(-29.391 -5)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.35494f9a2c4aec34e586aa78cd513fef.svg";
export { ForwardRef as ReactComponent };